import { hex2rgba } from './hex2rgba';
import { rgbStringToArray } from './rgb-string-to-array';
export const colorWithOpacity = (color: string, opacity = 1): string => {
  if (color.startsWith('#')) {
    try {
      return `rgba(${hex2rgba(color, opacity).join(',')})`;
    } catch {
      return color;
    }
  }
  if (color.startsWith('rgb(')) {
    const rgb = rgbStringToArray(color);
    if (Array.isArray(rgb)) {
      return `rgba(${rgb[0]}, ${rgb[1]}, ${rgb[2]}, ${opacity})`;
    }
    return color;
  }
  if (color.startsWith('rgba(')) {
    const [r = '0', g = '0', b = '0'] = color.replace('rgba(', '').replace(')', '').split(',').map(value => value.trim());
    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
  }
  return color;
};